import { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { appSoldOutNotify } from "../../../services/ProductService";
import { setOpenPoup } from "../../../store/actions/popupActions";

function NotifyMe({ productId }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showSoldOutNotLogin, setShowSoldOutNotLogin] = useState(false);
  const [showSoldOutLogin, setShowSoldOutLogin] = useState(false);
  const [showNotify, setShowNotify] = useState(true);
  const [showAlreadyNotified, setShowAlreadyNotified] = useState(false);

  const authState = useSelector((state) => state.auth);
  const onNotifyClick = () => {
    if (authState?.token && authState?.isAuthenticated && authState?.user) {
      // call api notify sold out product
      appSoldOutNotify(productId).then((res) => {
        res = JSON.parse(res.data);
        if (res?.status === "success") {
          setShowSoldOutNotLogin(false);
          setShowNotify(false);
          setShowSoldOutLogin(true);
          setShowAlreadyNotified(false);
        } else if (res?.status === "failure") {
          //   toast.error(res?.message || "");
          setShowAlreadyNotified(true);
          setShowSoldOutNotLogin(false);
          setShowNotify(false);
          setShowSoldOutLogin(false);
        }
      });
    } else {
      setShowSoldOutNotLogin(true);
      setShowNotify(false);
      setShowAlreadyNotified(false);
      setShowSoldOutLogin(false);
    }
  };

  const onLoginClick = () => {
    dispatch(setOpenPoup("login"));
  };

  const onSignupClick = () => {
    dispatch(setOpenPoup("signup"));
  };

  return (
    <>
      {showNotify && (
        <div
          className="newsletter"
          id="product-sold-ou-notify-me"
          style={{ display: "block", zIndex: "9999", padding: "0px" }}
        >
          <div className="bg"></div>
          <div className="center-box">
            <div className="newsletter-heading">
              <button
                onClick={() => {
                  // Check if there is a history stack to go back to
                  if (window.history.length > 1) {
                    navigate(-1); // Go back to the previous page if it exists
                  } else {
                    navigate('/'); // Redirect to the homepage (or product listing page) if no history
                  }
                }}
                className="btn-blank btn-side-cart-close"
              >
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/icons/Cross-Button.png"
                  }
                  className="close-btn-newsletter"
                  alt=""
                />
              </button>
              <h3>THIS ITEM GOT SOLD OUT</h3>
            </div>
            <div className="newsletter-body">
              <div className="row">
                <div className="col-md-11 mx-auto">
                  <div className="txt text-center mt-40">
                    <p className="text-black">
                      Click on the "Notify me" button and we'll try to make it
                      exclusively available for you!
                    </p>
                    <button
                      type="button"
                      onClick={onNotifyClick}
                      className="btn-primary btn-fw mt-30"
                    >
                      NOTIFY ME
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showSoldOutNotLogin && (
        <div
          className="newsletter"
          id="product-sold-ou-logged-out"
          style={{ display: "block", zIndex: "9999", padding: "0px" }}
        >
          <div className="bg"></div>
          <div className="center-box">
            <div className="newsletter-heading">
              <button
                onClick={() => {
                  // Check if there is a history stack to go back to
                  if (window.history.length > 1) {
                    navigate(-1); // Go back to the previous page if it exists
                  } else {
                    navigate('/'); // Redirect to the homepage (or product listing page) if no history
                  }
                }}
                className="btn-blank btn-side-cart-close"
              >
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/icons/Cross-Button.png"
                  }
                  className="close-btn-newsletter"
                  alt=""
                />
              </button>
              <h3>GET NOTIFIED</h3>
            </div>
            <div className="newsletter-body">
              <div className="row">
                <div className="col-md-11 mx-auto">
                  <div className="txt text-center mt-40">
                    <p className="text-black">
                      This item got sold out. To get notified when this item
                      comes back in stock.
                    </p>
                    <button
                      className="btn-primary btn-fw mt-20"
                      type="button"
                      onClick={onSignupClick}
                    >
                      SIGN UP
                    </button>
                    <p className="text-black mt-10">and get ₹500 off</p>
                    <p className="text-black mt-25">
                      <b>or</b>
                    </p>
                    <button
                      className="btn-primary btn-fw mt-40"
                      type="button"
                      onClick={onLoginClick}
                    >
                      LOGIN
                    </button>
                    <p className="text-black mt-10">
                      if you already have an account.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showSoldOutLogin && (
        <div
          className="newsletter"
          id="product-sold-ou-logged-in"
          style={{ display: "block", zIndex: "9999", padding: "0px" }}
        >
          <div className="bg"></div>
          <div className="center-box">
            <div className="newsletter-heading">
              <button
                onClick={() => {
                  // Check if there is a history stack to go back to
                  if (window.history.length > 1) {
                    navigate(-1); // Go back to the previous page if it exists
                  } else {
                    navigate('/'); // Redirect to the homepage (or product listing page) if no history
                  }
                }}
                className="btn-blank btn-side-cart-close"
              >
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/icons/Cross-Button.png"
                  }
                  className="close-btn-newsletter"
                  alt=""
                />
              </button>
              <h3>Thank You!</h3>
            </div>
            <div className="newsletter-body">
              <div className="row">
                <div className="col-md-11 mx-auto">
                  <div className="txt text-center mt-40">
                    <p className="text-black">
                      We will notify you once this item comes <br /> back in
                      stock.
                    </p>
                    <p className="text-black mt-40">
                      <b>But wait before you leave.</b>
                    </p>
                    <p className="text-black mt-40">
                      We have some amazing items waiting for you at{" "}
                      <b>up to 60%</b> off on your favourite designers.
                    </p>
                    <button
                      className="btn-primary btn-fw mt-30"
                      type="button"
                      onClick={() => {
                        // Check if there is a history stack to go back to
                        if (window.history.length > 1) {
                          navigate(-1); // Go back to the previous page if it exists
                        } else {
                          navigate('/'); // Redirect to the homepage (or product listing page) if no history
                        }
                      }}
                    >
                      CONTINUE SHOPPING
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showAlreadyNotified && (
        <div
          className="newsletter"
          id="product-sold-ou-logged-new"
          style={{ display: "block", zIndex: "9999", padding: "0px" }}
        >
          <div className="bg"></div>
          <div className="center-box">
            <div className="newsletter-heading">
              <button
                onClick={() => {
                  // Check if there is a history stack to go back to
                  if (window.history.length > 1) {
                    navigate(-1); // Go back to the previous page if it exists
                  } else {
                    navigate('/'); // Redirect to the homepage (or product listing page) if no history
                  }
                }}
                className="btn-blank btn-side-cart-close"
              >
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/icons/Cross-Button.png"
                  }
                  className="close-btn-newsletter"
                  alt=""
                />
              </button>
              <h3>Thank You!</h3>
            </div>
            <div className="newsletter-body">
              <div className="row">
                <div className="col-md-11 mx-auto">
                  <div className="txt text-center mt-40">
                    <p className="text-black">
                      The product has already been addded to your wait list. We
                      will notify you once this item comes back in stock.
                    </p>
                    <button
                      className="btn-primary btn-fw mt-30"
                      type="button"
                      onClick={() => {
                        // Check if there is a history stack to go back to
                        if (window.history.length > 1) {
                          navigate(-1); // Go back to the previous page if it exists
                        } else {
                          navigate('/'); // Redirect to the homepage (or product listing page) if no history
                        }
                      }}
                    >
                      CONTINUE SHOPPING
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default NotifyMe;
